import { render } from "./ApiKeyList.vue?vue&type=template&id=1c2b68c1&scoped=true&ts=true"
import script from "./ApiKeyList.vue?vue&type=script&lang=ts"
export * from "./ApiKeyList.vue?vue&type=script&lang=ts"

import "./ApiKeyList.vue?vue&type=style&index=0&id=1c2b68c1&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2b68c1"]])

export default __exports__